import { Stack } from '@mui/material';
import { categories } from '../utils/constants';

const Sidebar = ({ selectedCategory, setselectedCategory }) => (

	<Stack
		direction="row"
		sx={{
			overflowY: "auto",
			height: { sx: 'auto', md: '95%' },
			flexDirection: { md: 'column' }
		}}
	>
		{categories.map((category) => (
			<button className="category-btn"
				onClick={()=> setselectedCategory(category.name)}
				style={{
					background: category.name === selectedCategory  && '#fc1503' , color: 'white'
			}} key={category.name}>
				<span style={{color:category.name === selectedCategory ? 'white': 'red', marginRight: '15px'}}>{category.icon}</span>
				<spans style={{opacity:category.name === selectedCategory ? '1' : '1' }} >{category.name}</spans>
			</button>

		))}
	</Stack>
)


export default Sidebar